import type { HTMLAttributes, PropsWithChildren } from 'react';

import { cn } from '../../lib/utils';

type FieldDescriptionProps = PropsWithChildren<{
    className?: string;
    dataTestid?: string;
    htmlAttributes?: HTMLAttributes<HTMLParagraphElement>;
}>;

export const FieldDescription = ({ children, className, dataTestid, htmlAttributes }: FieldDescriptionProps) => (
    <p
        data-component-name='FieldDescription'
        className={cn('text-gray-500 text-xs mt-1', className)}
        data-testid={dataTestid}
        {...htmlAttributes}
    >
        {children}
    </p>
);
